import { render } from "./ShowNurseVisit.vue?vue&type=template&id=458bd7c6&scoped=true"
import script from "./ShowNurseVisit.vue?vue&type=script&lang=js"
export * from "./ShowNurseVisit.vue?vue&type=script&lang=js"

import "./ShowNurseVisit.vue?vue&type=style&index=0&id=458bd7c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458bd7c6"]])

export default __exports__